<template>
  <div id="chart">
    <v-skeleton-loader
      v-if="loading"
      type="image"
    />
    <apexchart
      v-else
      type="bar"
      height="350"
      :options="chartOptions"
      :series="series"
    />
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import { mapGetters } from "vuex";
export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
    }),
    series() {
      return [
        {
          name: "dispenser1",
          data: [4500, 2000, 8000, 10000, 6500, 7800],
        },
        {
          name: "dispenser2",
          data: [3800, 1200, 5000, 7000, 4200, 3900],
        },
        {
          name: "dispenser3",
          data: [4200, 800, 4200, 5000, 3200, 4100],
        },
        {
          name: "dispenser4",
          data: [3600, 700, 3500, 4000, 3000, 3800],
        },
      ];
    },
chartOptions() {
  return {
    chart: {
      type: "bar",
      height: 350,
      stacked: true,
      toolbar: {
        show: false,
      },
    },

    title: {
      text: "Dispenser Sale",
      align: "left",
      style: {
        fontSize: "18px",
        fontWeight: 600,
      },
    },

    colors: ["#20a390", "#49b8a7", "#75cec0", "#a2e3d8"],

    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        borderRadius: 2,
      },
    },

    dataLabels: {
      enabled: false,
    },

    stroke: {
      show: false,
    },

    xaxis: {
      categories: ["00:00", "04:00", "08:00", "12:00", "16:00", "20:00"],
    },

    legend: {
      position: "top",
    },

    fill: {
      opacity: 1,
    },

    grid: {
      borderColor: "#e5e7eb",
      strokeDashArray: 4,
    },
  };
},
  },
};
</script>
